// extracted by mini-css-extract-plugin
export default {"iconWrapper":"styles_iconWrapper__SoDep"};